import { useEffect, useState } from 'react';
import { getFaqs } from '../../api/api';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import './Faq.scss';

const Faq = () => {
    const [faqs, setFaqs] = useState([]);

    useEffect(() => {
        async function fetchData() {
            const data = await getFaqs();
            setFaqs(data);
        }
        fetchData();
    }, []);

    return (
        <section className='faq-section pt-50 pb-70'  data-aos="fade-up" data-aos-duration="2000">
            <div className="container">
                <SectionTitle
                    subTitle="FAQ"
                    title="Frequently asked question"
                />

                <div className="accordian-area">
                    <div className="accordion" id="accordionExample">
                        {faqs.map((faq, idx) => (
                            <div className="accordion-item" key={faq.id}>
                                <h2 className="accordion-header" id={`heading${idx}`}> 
                                    <button className={`accordion-button${idx === 0 ? '' : ' collapsed'}`} type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${idx}`} aria-expanded={idx === 0 ? 'true' : 'false'} aria-controls={`collapse${idx}`}>
                                        {faq.question}
                                    </button>
                                </h2>
                                <div id={`collapse${idx}`} className={`accordion-collapse collapse${idx === 0 ? ' show' : ''}`} aria-labelledby={`heading${idx}`} data-bs-parent="#accordionExample">
                                    <div className="accordion-body">
                                        {faq.answer}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Faq;